"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userEvents = void 0;
const USER_ACTION = 'user_action';
const APPOINTMENT_WAITLIST = 'appointment_waitlist';
exports.userEvents = {
    WAITLIST_DOB_CONFIRMED: `${USER_ACTION}.${APPOINTMENT_WAITLIST}.dob_confirmed`,
    WAITLIST_CONTINUE_CLICKED: `${USER_ACTION}.${APPOINTMENT_WAITLIST}.continue_clicked`
};
//# sourceMappingURL=Tracking.js.map